import Caption from 'LuxKit/Typography/Caption'
import { FormattedMessage } from 'react-intl'
import LuxPlusLogo from './Logos/LuxPlusLogo'
import { getAvailableInsuranceBenefits } from 'luxPlus/selectors/benefits/insurance'
import { useAppSelector } from 'hooks/reduxHooks'
import FormatCurrency from 'components/Common/FormatCurrency'

interface Props {
  logoHeight: number
  saveAmount: number
}

function LuxPlusInsuranceLabel(props: Props) {
  const { logoHeight, saveAmount } = props
  const luxPlusInsuranceBenefitView = useAppSelector(getAvailableInsuranceBenefits)
  const showBookingProtectionPercentage = saveAmount < luxPlusInsuranceBenefitView.luxPlusDiscountValueDisplayThreshold

  const luxPlusLogo = <LuxPlusLogo colour="inherit" height={logoHeight} />

  const percentageLabel = <FormattedMessage
    id="OykWwIJli-wvCpt0wVHR"
    defaultMessage="Save up to {percentage}% with {logo}"
    description="Insurance benefit label showing percentage savings with LuxPlus+"
    values={{ percentage: luxPlusInsuranceBenefitView.luxPlusDiscountPercentage, logo: luxPlusLogo }}
  />

  const currencyLabel = <FormattedMessage
    id="ZuzWh94BButNUj4MfhCG"
    defaultMessage="Save {saveAmount} with {logo}"
    description="Insurance benefit label showing currency savings with LuxPlus+"
    values={{ saveAmount: <FormatCurrency value={saveAmount} format="roundedDollar" />, logo: luxPlusLogo }}
  />

  return <Caption variant="medium" weight="bold">{showBookingProtectionPercentage ? percentageLabel : currencyLabel}</Caption>
}

export default LuxPlusInsuranceLabel
